import React from 'react';
import { Navigate } from 'react-router-dom';

import { PricingOptionsSummary } from './PricingOptionsSummary';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings/implementations" />;
    }}
  >
    <PricingOptionsSummary />
  </RouteErrorBoundary>
);
